module.exports = __webpack_public_path__ + "static/media/ecc-logo.65a683fa.png";